import { useEffect } from 'react';
import useAppStore from '../store/useAppStore';

// Class-based dark mode (Tailwind `darkMode: 'class'`) requires the class to be on
// <html> not a wrapper div. Listens for system preference changes when theme === 'system'.
export default function useThemeSync() {
  const theme = useAppStore((s) => s.theme);

  useEffect(() => {
    const apply = () => {
      let dark = false;
      if (theme === 'dark') dark = true;
      else if (theme === 'system') dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      document.documentElement.classList.toggle('dark', dark);
    };
    apply();
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => { if (theme === 'system') apply(); };
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [theme]);
}
